<template>
  <v-autocomplete @input="
    (event) => {
      $emit('input', event);
    }
  " :multiple="multiple ? true : false" v-model="selectedMember" :items="items" :label="label" item-text="name"
    item-value="_id" clearable outlined dense :hide-details="hideDetails ? hideDetails : false"></v-autocomplete>
</template>

<script>
import Api from "@/services/Api";
export default {
  data() {
    return {
      items: [],
      selectedMember: null,
    };
  },
  props: ["value", "label", "hideDetails", "multiple", "visitors"],
  created() {
    this.loading = true;
    Api()
      .get("admins/managedacademy/" + this.$store.state.managedAcademy + "/memberdatas")
      .then((response) => {
        const data = response.data;
        if (data) {
          this.items = data.list;
          if (this.visitors)
            this.selectedMember = this.visitors;
        }
      });
  },
  watch: {
    selectedMember: {
      immediate: false,
      handler: function (newValue) {
        this.$emit("visitor_picked", newValue);
      },
    },
  },
  methods: {
    assignValue() {
      if (this.value) {
        this.selectedMember = this.value;
      }
    }
  },
};
</script>

<style scoped></style>
